/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 * * `PENDING` - Pending
 * * `ACCEPTED` - Accepted
 * * `REJECTED` - Rejected
 */
export enum StatusByRepEnum {
    PENDING = 'PENDING',
    ACCEPTED = 'ACCEPTED',
    REJECTED = 'REJECTED',
}
